export default __webpack_public_path__ + "static/media/t1.148b9b22.jpeg";